module.exports = __webpack_public_path__ + "static/img/grow_award_2.a372ac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/mentoring/prentice/grow_award_2.png
// module id = FVIL
// module chunks = 1